/* ================================
   MAAKKA – SMART PREDICTIVE SEARCH
   ================================ */

console.log("Predictive search JS loaded");

document.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.querySelector(".search-input");
  const resultsBox = document.getElementById("predictive-search-results");

  if (!searchInput || !resultsBox) {
    console.warn("Search input or results box not found");
    return;
  }

  // ✅ GLOBAL, CONTROLLED CONCEPT MAP
  const conceptMap = {
    leggings: ["leggings", "tights", "activewear", "fitness", "gym"],
    headlamp: ["hiking", "camping", "outdoor", "trekking"],
    travel: ["travel", "flight", "trip", "journey"],
    neckpillow: ["neck pillow", "travel pillow", "flight pillow"],
    desklamp: ["study", "office", "work"],
    pet: ["pet", "dog", "cat"]
    };

  // Map vague / imperfect words to better intent
  const vagueSearchMap = {
    "item": "daily",
    "thing": "essentials",
    "product": "shop",
    "home": "home essentials",
    "pet": "pet supplies",
    "dog": "dog",
    "cat": "cat"
  };

  let timeout;

  searchInput.addEventListener("input", () => {
    let query = searchInput.value.trim().toLowerCase();

    // Clear dropdown if too short
    if (query.length < 2) {
      resultsBox.innerHTML = "";
      return;
    }

    // Improve vague searches automatically
    const finalQuery = vagueSearchMap[query] || query;

    clearTimeout(timeout);

    timeout = setTimeout(async () => {
      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(finalQuery)}&resources[type]=product&resources[limit]=6`
        );

        const data = await response.json();
        let products = data?.resources?.results?.products || [];

        if (products.length === 0) {
          resultsBox.innerHTML = "";
          return;
        }

        // Prioritise products that contain the search word in title
        products = products.sort((a, b) => {
          const aMatch = a.title.toLowerCase().includes(query) ? 1 : 0;
          const bMatch = b.title.toLowerCase().includes(query) ? 1 : 0;
          return bMatch - aMatch;
        });

        resultsBox.innerHTML = products
          .map(
            p => `
              <a href="${p.url}" class="predictive-item">
                <img src="${p.image}" alt="${p.title}">
                <span>${p.title}</span>
              </a>
            `
          )
          .join("");
      } catch (err) {
        console.error("Predictive search failed", err);
      }
    }, 300);
  });

  // Hide dropdown when clicking outside search
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".header-search")) {
      resultsBox.innerHTML = "";
    }
  });
});
